import transformOptions from "./transformOptions";
import transformResult from "./transformResult";

const apiUtils = {
    transformOptions,
    transformResult,    
}

export default apiUtils;